<template>
  <div class="check-footer">
    <div v-if="type != 'checkres'"
         class="check-footer-btn">
      <div class="check-active pointer"
           @click="nextCheck"
           v-if="type == 'mic' || type =='camera'">{{$t('check.cansee')}}</div>
      <div class="check-active pointer"
           @click="nextCheck"
           v-if="type == 'speaker'">{{$t('check.canhear')}}</div>
      <div class="check-default pointer"
           v-if="type == 'mic' || type =='camera'"
           @click="nextCheck(type)">{{$t('check.nosee')}}</div>
      <div class="check-default pointer"
           v-if="type == 'speaker'"
           @click="nextCheck(type)">{{$t('check.nohear')}}</div>
    </div>
    <div v-else
         class="check-footer-golive">
      <el-checkbox v-model="openCamera"
                   @change="changeCamera">{{$t('check.opencamera')}}</el-checkbox>
      <el-checkbox v-model="openMic"
                   @change="changeMic">{{$t('check.openmic')}}</el-checkbox>
      <div class="check-footer-golive-btn pointer"
           @click="goLive"><span v-if="selfType == 1 ">{{$t('check.joinlive')}}</span><span v-else>{{$t('check.golive')}}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkFooter',
  props: ['type'],
  data () {
    return {
      openCamera: true,
      openMic: true
    }
  },
  computed: {
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type
      );
    },
    micDefault(){
      console.log(this.$store.getters.micDefault, "this.$store.getters.micDefault");
      return this.$store.getters.micDefault;
    },
    selfType () {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
  },
  watch: {
    micDefault: {
      immediate: true,
      handler: function (value) {
        if(value == 2 && this.role == 1){
          this.openMic = false;
          this.openCamera = false;
        } 
      },
    },
  },
  methods: {
    changeCamera () {
      const status = this.openCamera ? 'active' : 'inactive'
      this.$store.commit('SET_SELFVIDEOSTATUS', status)
    },
    changeMic () {
      const status = this.openMic ? 'active' : 'inactive'
      this.$store.commit('SET_SELFAUDIOSTATUS', status)
    },
    nextCheck (notype) {
      this.changeCamera();
      this.changeMic();
      this.$parent.nextCheck(notype)
    },
    // 去直播
    goLive () {
      this.$nextTick(() => {
        this.$store.commit('SET_ISCHECK', false)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.check-footer {
  position: absolute;
  width: 100%;
  bottom: 0px;

  .check-footer-btn > div {
    width: 50%;
    height: 62px;
    line-height: 62px;
    display: inline-block;
    font-size: 18px;
  }
  .check-active {
    background-color: $bule-color;
    color: $white-color;
    border-radius: 0px 0px 0px 8px;
  }
  .check-default {
    background-color: $grey4-color;
    color: $chatusertabfont-color;
    border-radius: 0px 0px 8px 0px;
  }
  .check-footer-golive {
    position: relative;
    padding: 30px 0px;
    &::before {
      content: '';
      position: absolute;
      left: 30px;
      right: 30px;
      top: 0;
      height: 1px;
      background-color: rgba($color: $purple-color, $alpha: 0.6);
      transform: scaleY(0.5);
    }
    ::v-deep {
      .el-checkbox:not(.is-checked) {
        color: #acb2bf;
        .el-checkbox__inner {
          border-color: #8a8f99;
          background-color: transparent;
        }
      }
    }
  }
  .check-footer-golive-btn {
    background-color: $bule-color;
    color: $white-color;
    width: 300px;
    height: 60px;
    line-height: 60px;
    border-radius: 6px;
    margin: 46px auto 0px auto;
  }
}
</style>